import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Select from "react-select";
import HttpClient from "../utils/HttpClient";
import toast from 'react-hot-toast';

const AddBusinessServiceModal = ({ closemodal, ids, services, setServices, updateForm, data, setIsUpdate }) => {
  const { UserProfileID } = useSelector((state) => state.app);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [serviceName, setServiceName] = useState("");
  // New state to control visibility of "Add New Service" elements
  const [showAddNewService, setShowAddNewService] = useState(false);

  const submit = (e) => {
    e.preventDefault()

    const flatSelectedOptions = selectedOptions.map((item) => item.value)
    const flatSelectedOptionsName = selectedOptions.map((item) => item.label)

    const updatedServices = [...services, ...flatSelectedOptionsName];
    const updatedServicesIds = [...ids, ...flatSelectedOptions];

    setServices(updatedServices);
    selectedOptions?.length > 0 && updateForm("businessProductCat", updatedServices);
    selectedOptions?.length > 0 && updateForm("businessProductCatId", updatedServicesIds);

    setSelectedOptions([])
    setIsUpdate(true)
    closemodal(false);
  };

  const [serviceOptions, setServiceOptions] = useState([])

  const getCompanyTypeWiseServices = async (id) => {
    try {
      const res = await HttpClient.requestData(`companyType-wise-servicess/${id}`, "GET");
      if (res?.status) {
        const filteredData = res.data.filter(
          // Filter out services already selected
          (item) => !ids.includes(item._id)
        );

        setServiceOptions(filteredData.map((item) => ({
          value: item._id,
          label: item.name,
        })) || []);
      }
    } catch (error) {
      console.error("Error occured!", error);
    }
  };

  const createService = async () => {
    if (!serviceName.trim()) {
      toast.error("Service name cannot be empty");
      return;
    }
    const dataToSend = {
      companyTypeID: UserProfileID?.companyTypeID || data?.companyTypeID,
      name: serviceName.trim()
    }
    try {
      const response = await HttpClient.requestData(`service`, "POST", dataToSend);
      if (response.status) {
        toast.success("Service created successfully!");
        setServiceName("");
        setShowAddNewService(false);
        getCompanyTypeWiseServices(UserProfileID?.companyTypeID || data?.companyTypeID);
      } else {
        toast.error(response.message || "Failed to create service.");
      }
    } catch (error) {
      console.error("Error creating service:", error);
      toast.error("An unexpected error occurred.");
    }
  }

  useEffect(() => {
    getCompanyTypeWiseServices(UserProfileID?.companyTypeID || data?.companyTypeID)
  }, [])

  const handleServiceChange = (selected) => {
    const newTotKeywords = services.length + selected.length;
    if (newTotKeywords > 5) {
      toast.error("Cannot add more services — limit reached")
    } else {
      setSelectedOptions(selected);
    }
  };

  return (
    <div className="edittamodalboixshadow">
      <div className="edittamodalboixsbg">
        {/* <div className="crossdivicon" onClick={() => closemodal(false)}>
          <i className="fa-solid fa-xmark" style={{ marginTop: "8px" }}></i>
        </div>
        <div className="edittappduudivnhhb">
          <h4 className="upldbannertrtxtpp">Add Services</h4>
        </div> */}
        <h5 className="mt-2 p-0 m-3">Add Services</h5>
        <div className="crossdivicon" onClick={() => closemodal()} style={{ cursor: "pointer" }}>
          <i className="fa-solid fa-xmark"></i>
        </div>
        <hr />
        <div className="abattstdovvstttschgg">
          {/* Service Select Box */}
          <Select
            options={serviceOptions}
            isMulti
            value={selectedOptions}
            onChange={handleServiceChange}
            placeholder="Select services..."
          />

          {/* "Add More" Button */}
          {!showAddNewService && (
            <div style={{ marginTop: '10px' }}>
              <button
                onClick={() => setShowAddNewService(true)}
                className="svavtatvvbtnnm" // Reusing the button class for basic styling
                style={{ background: '#007bff', color: '#fff', border: 'none', padding: '8px 15px', borderRadius: '4px', cursor: 'pointer' }}
              >
                Add More
              </button>
            </div>
          )}

          {/* Add New Service Input and Save Button */}
          {showAddNewService && (
            <div style={{ marginTop: '10px', display: 'flex', gap: '10px', alignItems: 'center' }}>
              <input
                type="text"
                value={serviceName}
                onChange={(e) => setServiceName(e.target.value)}
                placeholder="Enter new service name"
                style={{ flexGrow: 1, padding: '8px', border: '1px solid #ccc', borderRadius: '4px' }}
              />
              <button
                onClick={createService}
                className="svavtatvvbtnnm"
                style={{ background: '#28a745', color: '#fff', border: 'none', padding: '8px 15px', borderRadius: '4px', cursor: 'pointer' }}
              >
                Save
              </button>
            </div>
          )}

          {/* Main Save Button for Selected Services */}
          {selectedOptions?.length > 0 && (
            <div className="svavtatvvbtnnmpaggdijbtn">
              <button
                onClick={(e) => submit(e)}
                className="svavtatvvbtnnm">
                Save Selected
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddBusinessServiceModal;